import { SUBSCRIPTION_STATUSES } from "utils/constants";

const pendingCountsAsInfoCompleted = (status) =>
  status === SUBSCRIPTION_STATUSES.PENDING;

export const subscriptionCanBeSigned = ({ status, additionalInfo }) => {
  if (additionalInfo?.allowManualSignature) return true;
  const infoCompleted =
    Boolean(additionalInfo?.isInfoCompleted) ||
    pendingCountsAsInfoCompleted(status);
  return infoCompleted && Boolean(additionalInfo?.isDocumentsCompleted);
};

export const subscriptionSignPopover = ({ status, additionalInfo }, labels) => {
  if (subscriptionCanBeSigned({ status, additionalInfo })) return "";
  const missingInfo =
    !pendingCountsAsInfoCompleted(status) && !additionalInfo?.isInfoCompleted;
  const missingDocuments = !additionalInfo?.isDocumentsCompleted;
  if (missingInfo && missingDocuments) return labels.POPOVER;
  if (missingInfo) return labels.MISSING_INFO;
  if (missingDocuments) return labels.MISSING_DOCUMENTS;
  return labels.POPOVER;
};
